import { ButtonSelectComponent } from './button-select/button-select.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { DclComponent } from './dcl/dcl.component';
import { TriggerComponent } from './trigger/trigger.component';
import { TableComponent } from './table/table.component';
import { CustomColumnComponent } from './custom-column/custom-column.component';
import { CommonModule } from '@angular/common';

import { ButtonComponent } from './button/button.component';
import { PopoverContentComponent } from './popover-content/popover-content.component';
import { InputTooltipComponent } from './input-tooltip/input-tooltip.component';

import { DialogComponent } from './dialog/dialog.component';
import { DialogService } from './dialog/dialog.service';

import { SnackbarComponent } from './snackbar/snackbar.component';
import { SnackbarService } from './snackbar/snackbar.service';

import { PopoverDirective } from './directives/popover.directive';
import { InputTooltipDirective } from './directives/input-tooltip.directive';

import { DemoMaterialModule } from './material.imports';
import { SelectComponent } from './select/select.component';
import { InfoTipButtonComponent } from './info-tip-button/info-tip-button.component';
import { RequestHelpButtonComponent } from './request-help-button/request-help-button.component';
import { MessageViewerComponent } from './message-viewer/message-viewer.component';
import { PaginatorComponent } from './paginator/paginator.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TextFieldComponent } from './search/text-field.component';
import { TableSelectFilterComponent } from './table-select-filter/table-select-filter.component';
import { TableSearchFilterComponent } from './table-search-filter/table-search-filter.component';
import { TableTagsFilterComponent } from './table-tags-filter/table-tags-filter.component';
import { SvgRendererComponent } from './svg-renderer/svg-renderer.component';
import { TimezonePipe } from './pipes/timezone.pipe';
import { HtmlViewerComponent } from './html-viewer/html-viewer.component';
import { TableMobileRowDirective } from './directives/table-mobile-row.directive';
import { MenuButtonComponent } from './menu-button/menu-button.component';
import { CopyTextDirective } from './directives/copy-text.directive';

export const UI_DECLARATIONS = [
  ButtonComponent,
  DialogComponent,
  SnackbarComponent,
  PopoverContentComponent,
  PopoverDirective,
  InputTooltipDirective,
  InputTooltipComponent,
  TableComponent,
  SelectComponent,
  TriggerComponent,
  DclComponent,
  CheckboxComponent,
  ButtonSelectComponent,
  InfoTipButtonComponent,
  RequestHelpButtonComponent,
  MessageViewerComponent,
  CustomColumnComponent,
  PaginatorComponent,
  TextFieldComponent,
  TableSelectFilterComponent,
  TableSearchFilterComponent,
  TableTagsFilterComponent,
  SvgRendererComponent,
  TimezonePipe,
  HtmlViewerComponent,
  TableMobileRowDirective,
  MenuButtonComponent,
  CopyTextDirective,
];

export const UI_IMPORTS = [CommonModule, DemoMaterialModule, NgSelectModule];

export const UI_PROVIDERS = [DialogService, SnackbarService];

export const UI_ENTRY_COMPONENTS = [
  ButtonComponent,
  PopoverContentComponent,
  InputTooltipComponent,
  DialogComponent,
  SnackbarComponent,
  TableComponent,
  SelectComponent,
  TriggerComponent,
  DclComponent,
  CheckboxComponent,
  ButtonSelectComponent,
  InfoTipButtonComponent,
  RequestHelpButtonComponent,
  MessageViewerComponent,
  CustomColumnComponent,
  TableSelectFilterComponent,
  TableSearchFilterComponent,
  TableTagsFilterComponent,
  SvgRendererComponent,
  HtmlViewerComponent,
  TableMobileRowDirective,
  MenuButtonComponent,
];
